module.exports = __webpack_public_path__ + "img/Daikin_Footer.76caac8c.png";